import {
  formataMetaAlcancada,
  formataNSA,
  formatBRL,
  formatDataHoraBR,
  formatResultadoIndicadorBRL
} from '../../util/utilitarios';

import ModalTextoSimples from '../ModalTextoSimples';

import { useEffect, useState } from 'react';

function IndicadorTabelaHistorico({ indicador, exibirJustificativa, onlyLatest }) {

  const [showModal, setShowModal] = useState(false)
  const [justificativaModal, setJustificativaModal] = useState(false)

  const exibirTabela =
    onlyLatest || indicador.numeroVersao >= 2;

  const listaIndicadores = [];

  if (onlyLatest) {
    listaIndicadores.push(indicador);
  } else if (indicador.numeroVersao >= 2) {
    listaIndicadores.push(...indicador.historicoDeVersoes);
    listaIndicadores.push(indicador);
  }

  const openModal = (justificativa) => {
    setShowModal(true)
    setJustificativaModal(justificativa)
  }

  return (
    <>

      <ModalTextoSimples
        show={showModal}
        setShow={setShowModal}
        modalTitle={'Justificativa do indicador'}
        text={justificativaModal}
      />

      {
        exibirTabela ? (
          <table className="table" >
            <thead>
              <tr>
                <th>Numerador</th>
                <th>Denominador</th>
                <th>Resultado</th>
                <th>Meta Alcançada</th>
                <th>Numero Versão</th>
                <th>Criador da versão</th>
                <th>Data criação versão</th>
                {exibirJustificativa && <th>Justificativa</th>}
              </tr>
            </thead>
            <tbody>
              {listaIndicadores.map((indicador, index) => (
                <tr
                  key={indicador.id}
                  style={
                    index === listaIndicadores.length - 1
                      ? { '--bs-table-bg': '#d1d1d1' }
                      : undefined
                  }
                >
                  <td>{indicador.nsa ? 'NSA' : formatBRL(indicador.numerador)}</td>
                  <td>{indicador.nsa ? 'NSA' : formatBRL(indicador.denominador)}</td>
                  <td>{indicador.nsa ? 'NSA' : formatResultadoIndicadorBRL(indicador.resultado, indicador.resultadoEmPorcentagem)}</td>
                  <td>{indicador.metaAlcancada ? 'SIM' : 'NÃO'}</td>
                  <td>{indicador.numeroVersao}</td>
                  <td>{indicador.createUserName}</td>
                  <td>{formatDataHoraBR(indicador.createDate)}</td>
                  {exibirJustificativa &&
                    <td>
                      <button
                        className={indicador.justificativa?.trim() ? "btn btn-primary" : "btn btn-secondary"}
                        onClick={() => openModal(indicador.justificativa)}
                      > VER
                      </button>
                    </td>
                  }
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <div className='text-center'>
            <p className='fs-5 m-0'>O indicador encontra-se na primeira versão, portanto, não possui histórico.</p>
          </div>
        )
      }
    </>
  );
}

export default IndicadorTabelaHistorico;
